<template>
    <div class="mt-4">
      <fragment>
        <page-head
          small
          :back-route-path="'/bankruptcy'"
          show-back
          :back-text="local.common.cancel"
        >
        </page-head>
        <page-content
          small
          class="content-box"
        >
          <div>
            <p class="session-title">{{ this.local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.title }} {{this.requestInfo.code}}</p>
          </div>
          <div class="attribute-item-row my-3 d-flex">
            <div
              v-for="attribute in displayItems"
              :key="attribute.key"
              class="attribute-item pa-1"
            >
              <div class="attribute-item-title">
                {{ attribute.displayName }}
              </div>
              <div class="attribute-item-value">
                {{ attribute.formatter? attribute.formatter(requestInfo[attribute.key]):requestInfo[attribute.key] }}
              </div>
            </div>
          </div>
          <v-row>
            <v-tabs
              v-model="tab"
              class="pt-5"
              background-color="white"
              slider-color="rgb(54, 197, 186)"
              active-class="tab-active"
            >
              <v-tab
                v-for="tabButton in tabsButtons"
                :key="tabButton.href"
                class="tab-padding"
                :href="tabButton.href"
                @click="changeTab(tabButton)"
              >
                {{ tabButton.title }}
              </v-tab>
            </v-tabs>
            <naj-box
              class="mt-3"
              has-footer
              :title="local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.questionsAndAnswers">
              <v-col cols="12">
                <v-tabs-items v-model="tab">
                  <v-tab-item
                    v-if="selectedTab.role == 'myQuestions'"
                    value="tab-1"
                  >
                    <div
                      v-for="(item, index) in allQuestions.filter(x => x.isMyQuestion === true)"
                      :key="index"
                      cols="4"
                    >
                      <questions-and-answers
                        :info-item="item"
                        @onReplyQuestion="replyQuestion"
                      >
                      </questions-and-answers>
                    </div>
                  </v-tab-item>
                  <v-tab-item
                    v-if="selectedTab.role == 'allQuestions'"
                    value="tab-2"
                  >
                    <div
                      v-for="(item, index) in allQuestions"
                      :key="index"
                      cols="4"
                    >
                      <questions-and-answers 
                      :info-item="item"
                      @onReplyQuestion="replyQuestion"
                      >
                      </questions-and-answers>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <template v-slot:footer>
                <v-row>
                  <div
                    v-if="allowedToAnswer"
                    class="elitigation-block answer row col-12 wrapper"
                  >
                    <div class="col-12 judicial-department">
                      <span>{{local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.bankruptcyPreparationDepartment}}</span>
                    </div>
                    <div class="col-12">
                      <span> {{ selectedAnswer.questionText }} </span>
                    </div>
                    <div
                      class="removeAnswer"
                    >
                      <naj-button
                        type="button"
                        color="default"
                        icon="mdi-close"
                        @click="removeAnswer"
                      >
                      </naj-button>
                    </div>
                  </div>
                  <div
                    class="row col-12 wrapper"
                  >
                    <naj-input
                      :type-id="formFieldType.textarea"
                      :value.sync="questionAnswer"
                      :disabled="!allowedToAnswer"
                      :placeholder="local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.reply"
                      rows="1"
                      validates="max:10000"
                      class="reply-input"
                    ></naj-input>
                    <naj-button
                      text
                      type="button"
                      color="default"
                      icon="mdi-paperclip"
                      :disabled="!allowedToAnswer || attachmentFileName"
                      @click="viewAttachmentModal"
                      class="mt-8"
                    >
                    </naj-button>
                    <naj-button
                      type="button"
                      color="primary"
                      :label="local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.text"
                      :disabled="!allowedToAnswer"
                      @click="sendAnswer"
                      class="mt-8"
                    >
                      {{ local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.send }}
                    </naj-button>
                    <div
                      v-if="attachmentFileName"
                      class="attachment-section-wrapper"
                    >
                      <div class="attachment-buttons-container">
                        <naj-button class="attachment-view-button" @click="showAttachmentFile" outlined> 
                          <v-icon
                            color="var(--app-primary-color)"
                            class="icon-in-button"
                          >
                            mdi-file-document
                          </v-icon>{{ attachmentFileName }}</naj-button>
                        <div
                          class="icon-button">
                          <v-icon
                            color="red"
                            @click="showRemoveFileConfirmationModal = true; "
                          >
                            mdi-delete
                          </v-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-row>
              </template>
            </naj-box>
          </v-row>
        </page-content>
      </fragment>
      <request-reason-modal
        :modal-visibility="showAttachmentModal"
        @addRequestReasonAttachment="addAttachment"
        @onClose="hideAttachmentModal"
      >
      </request-reason-modal>
      <render-attachment-modal
        :attachment-file="uploadedFile"
        :modal-visibility="showViewAttachmentModal"
        @modalClose="hideViewAttachmentModal"
      >
      </render-attachment-modal>
      <naj-confirmation
        :show-modal="showRemoveFileConfirmationModal"
        :title="local.common.removeConfirmation"
        :message="local.caseFile.session.remoteArgument.removeFileDataAttachmentMessage"
        :ok-btn-label="local.common.remove"
        :close-btn-label="local.common.no"
        @ok="() => {
          showRemoveFileConfirmationModal = false;
          handleRemoveAttach();
        }"
        @cancel="showRemoveFileConfirmationModal = false"
      ></naj-confirmation>
      <div class="d-flex justify-end">
        <router-link
          :to="`/bankruptcy/bankruptcy-file/${requestObjectKey}`"
        >
          <naj-button class="back-button" outlined>{{ local.common.close }}</naj-button>
        </router-link>
      </div>
    </div>
  </template>
  
  <script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapActions } = createNamespacedHelpers('BankruptcyModule');
  const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
  import { toHijriDate } from '@/helpers/utils';
  import { sessionStatus } from '@/helpers/enum';
  import questionsAndAnswers from './questionsAndAnswers.vue';
  import RequestReasonModal from '@/components/shared/request-reason-modal/index';
  import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal';
  
  export default {
    name: 'ElitigationSessions',
    components: {
      questionsAndAnswers,
      RequestReasonModal,
      RenderAttachmentModal,
    },
    data() {
      return {
        requestInfo: {},
        debtorsDetails: {},
        myQuestions: [],
        allQuestions: [],
        toHijriDate,
        selectedTab: {},
        tab: null,
        tabsButtons: [
          {
            href: '#tab-1',
            title: this.local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.myQuestions,
            role: 'myQuestions',
            total: null,
          },
          {
            href: '#tab-2',
            title: this.local.bankruptcy.bankruptcyFile.sessions.elitigationSessions.allQuestions,
            role: 'allQuestions',
            total: null,
          },
        ],
        questionAnswer: '',
        selectedAnswer: {},
        allowedToAnswer: false,
        allowedToAttach: false,
        selectedAttachment: null,
        submitLoading: false,
        attachmentFileName: null,
        showViewAttachmentModal: false,
        selectedFile: {},
        showAttachmentModal: false,
        uploadedFile: {},
        showRemoveFileConfirmationModal: false,
      };
    },
    computed: {
      ...mapGlobalState(['userInfo']),
      requestObjectKey() {
        return this.$route.params.requestObjectKey;
      },
      sessionObjectKey() {
        return this.$route.params.sessionObjectKey;
      },
      headers() {
        return [
          {
            key: 'code',
            displayName: this.local.bankruptcy.bankruptcyFile.requestCode,
          },
          {
            key: 'creationDate',
            displayName: this.local.bankruptcy.bankruptcyFile.requestDate,
            formatter: toHijriDate,
          },
          {
            key: 'legalCapacityName',
            displayName: this.local.bankruptcy.bankruptcyFile.legalCapacityName,
          },
          {
            key: 'requestOwnerTypeName',
            displayName: this.local.bankruptcy.bankruptcyFile.onBehalfOf,
          },
          {
            key: 'debtorName',
            displayName: this.local.bankruptcy.debtorForm.debtorName,
          },
          {
            key: 'requestCategoryName',
            displayName: this.local.bankruptcy.bankruptcyFile.requestCategoryName,
          },
          {
            key: 'procedureName',
            displayName: this.local.bankruptcy.bankruptcyFile.procedureName,
          },
          {
            key: 'requestStatusName',
            displayName: this.local.bankruptcy.bankruptcyFile.requestStatusName,
          },
        ];
      },
      displayItems() {
        return this.headers.map((prop) => {
          prop.value = this.requestInfo[prop.key];
          return prop;
        }).filter(item => item.value);
      },
    },
    mounted() {
      this.loading = true;
      this.selectedTab = this.tabsButtons[0];
      this.getBasicSessionData();

      this.getELitigationSessionQuestionsAndAnswers(this.sessionObjectKey)
        .then((res) => {
          if(res.data[0].sessionStatusId == sessionStatus.new){
            this.$router.push({ path: `/bankruptcy/bankruptcy-file/${this.requestObjectKey}` });
          }
          this.allQuestions = res.data.map(question => ({
            ...question,
            isMyQuestion: (this.userInfo.isOrganizationUser && (question.commercialRegistrationNumber == this.userInfo.commercialRecordNumber || question.unifiedNumber == this.userInfo.nationalRecordNumber)) || question.socialId == this.userInfo.socialId  ? true : false,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    methods: {
      ...mapActions([
        'getMainRequestInfo',
        'getDebtorsDetails',
        'getELitigationSessionQuestionsAndAnswers',
        'sendAnswerForElitigationQuestion',
      ]),
      hideViewAttachmentModal() {
        this.showViewAttachmentModal = false;
      },
      handleRemoveAttach() {
        this.attachmentFileName = null;
        this.selectedAnswer['spid'] = null;
        this.selectedAnswer['fileName'] = null;
        this.selectedAnswer['extention'] = null;
      },
      showAttachmentFile() {
        var isImageFile = false;
        var validImageTypes = ['.gif', '.jpeg', '.png', '.jpg'];
        if (validImageTypes.includes(this.selectedAnswer.extention)) {
          isImageFile = true;
        }
        this.uploadedFile = {
          name: this.selectedAnswer.fileName,
          sharePointId: this.selectedAnswer.spid,
          isImage: isImageFile,
        };
        this.showViewAttachmentModal = true;
      },
      changeTab(tab) {
        if (tab != this.selectedTab) {
          this.selectedTab = tab;
        }
      },
      getBasicSessionData() {
        var info = {};
        this.getMainRequestInfo(this.requestObjectKey)
          .then((res) => {
            info = res.data;
            this.getDebtorsDetails(this.requestObjectKey)
              .then((detail) => {
                info["debtorName"] = detail.data.fullName;
                this.requestInfo = info;
              })
              .finally(() => {
                this.loading = false;
              });
          });
      },
      removeAnswer() {
        this.selectedAnswer = {};
        this.allowedToAnswer = !this.allowedToAnswer;
        this.uploadedFile = {};
        this.attachmentFileName = null;
      },
      replyQuestion(answer) {
        this.allowedToAnswer = true;
        this.allowedToAttach = answer.isAllowedAttachment;
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        this.selectedAnswer = { 
          answerObjectKey: answer.answerObjectKey,
          questionObjectKey: answer.questionObjectKey,
          questionText: answer.questionText,
          answerText: this.questionAnswer,
          socialId: answer.socialId,
          mainRequestObjectKey: this.requestObjectKey,
        };
      },
      submitUploadAttachment(data) {
        data.requestObjectKey = this.requestObjectKey;
        this.selectedAttachment = data;
        this.attachmentFileName = data.attachment.name;
        this.$refs.attachmentModalComponent.closeModal();
      },
      hideAttachmentModal() {
        this.showAttachmentModal = false;
      },
      sendAnswer() {
        this.selectedAnswer['answerText'] = this.questionAnswer;
        this.sendAnswerForElitigationQuestion(this.selectedAnswer)
          .then(() => {
            window.location.reload();
          });
      },
      viewAttachmentModal() {
        this.showAttachmentModal = true;
      },
      addAttachment(file) {
        this.attachmentFileName = file.sharePointFileName;
        this.selectedAnswer['spid'] = file.sharePointId;
        this.selectedAnswer['fileName'] = file.sharePointFileName;
        this.selectedAnswer['extention'] = file.extension;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .session-title {
    font-weight: 1000;
    font-size: 18px;
  }
  
  ::v-deep .mt-8 {
    margin-top: 34px !important;
  }

  ::v-deep .input-container {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    width: auto;
  }

  ::v-deep .naj-box-footer {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }

  .attribute-item-row {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: nowrap;
    border: 1px solid #dbdbdb;
    background: white;
  }

  .attribute-item {
    flex: 1 1 auto;
    padding: 15px 20px !important;

    &:first-child {
      background: #faf9f4;
      border-inline-start: none;
    }
  }

  .reply-input {
    flex: 1 1 auto;
  }

  textarea {
    margin-top: 2px;
  }

  .wrapper {
    margin: 0;
    padding: 0;
  }

  .attribute-item-title {
    font-size: 12px;
    font-weight: bold;
    color: #5f6368;
  }

  .attribute-item-value {
    font-size: 16px;
    font-weight: bolder;
  }

  .back-button {
    margin: 13px;
  }

  .icon-button {
    margin: 8px;
  }
  
  .tab-padding {
    font-size: 16px;
    padding-bottom: 20px;
    color: var(--app-dark-primary-color) !important;
    .v-chip {
      cursor: pointer;
      color: #ffffff;
      background: var(--app-dark-primary-color) !important;
      border-radius: 0px !important;
    }
  }

  .tab-active {
    color: var(--app-primary-color) !important;
    font-weight: bold;
  
    .v-chip {
      background: var(--app-lighter-primary-color) !important;
    }
  }

  ::v-deep .v-tabs {
    border-bottom: 1px solid #dbdbdb;
    .v-tabs-bar {
      .v-tabs-slider-wrapper {
        height: 3px !important;
      }
    }
  }

  ::v-deep .v-tab {
    max-width: unset;
  }

  .elitigation-block {
      border: 1px solid #ccc;
      border-radius: 10px;
      font-size: 14px;
      font-weight: bold;
      color: black;
  }

  .elitigation-block .judicial-department span{
  color: #009587 !important;
  }

  .elitigation-block.answer{
      background-color: #f8f8f9;
      border-right:5px solid #009587;
      margin-top: 10px;
  }

  .removeAnswer {
    position: absolute;
    left: 0px;
    top: 15px;
  }

  .attachment-buttons-container{
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .attachment-section-wrapper{
    width: 100%;
    margin-bottom: 20px;
  }

  .attachment-view-button{
    margin: 0;
  }

  .attachment-view-button naj-button {
    margin: 0;
  }

  .icon-in-button {
    right: -5;
  }
  </style>